export default "__VITE_ASSET__gNTpMcpY__"